export default function(options) {

    // Used http://stackoverflow.com/a/9405113 as source for .fn and .inverse
    return (ISMOBILE) ? options.fn(this) : options.inverse(this);
}
